import { render, staticRenderFns } from "./ScatterChartPanel.vue?vue&type=template&id=bfbc377e&scoped=true"
import script from "./ScatterChartPanel.vue?vue&type=script&lang=js"
export * from "./ScatterChartPanel.vue?vue&type=script&lang=js"
import style0 from "./ScatterChartPanel.vue?vue&type=style&index=0&id=bfbc377e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbc377e",
  null
  
)

export default component.exports